<template>
  <div class="footer-w">
    <ul class="tab-w">
      <li class="tab-l" v-for="(i,key) in tabs" :key="key" @click="goto(i.to)">
        {{i.title}}
      </li>
      <!-- <li class="tab-l">
        <div>联系QQ/微信：123456789</div>
        <div>联系邮箱：aka@vsdfsv.com</div>
        <div>联系电话：(010) 8373 8811</div>
        <div>联系地址：北京市丰台区卢沟桥街道大瓦窑北路1号院3号楼</div>
      </li> -->
      <li class="tab-l">
        <div>欢迎关注微信公众号</div>
        <div class="qrcode">
          <img src="../../assets/img/footer/HAQrcode.jpg" alt="公众号">
        </div>
        <div>地址：北京市丰台区卢沟桥街道大瓦窑北路1号院3号楼</div>
      </li>
    </ul>
    <div class="icp">© 2023 恒安卫士(深圳)电子科技发展有限公司北京分公司</div>
    <!-- <div class="icp">© 2023 恒安卫士(深圳)电子科技发展有限公司北京分公司 | 版权所有： 京ICP备xxxx号、 京公网安备xxxxxxxx1号</div> -->
  </div>
</template>
<script>
export default {
  name: 'vfooter',
  data () {
    return {
      activated: '/',
      tabs: [
        {title: '首页', to: '/'},
        {title: '关于我们', to: '/about'},
        {title: '技术创新', to: '/tech'},
        {title: '产品介绍', to: '/product'},
        {title: '新闻资讯', to: '/news'},
        {title: '联系我们', to: '/contact'}
      ]
    }
  },
  mounted () {},
  methods: {
    goto (i) {
      this.$router.push(i)
    }
  }
}
</script>
<style scoped>
.footer-w{
  width: 100%;
  height: 380px;
  background: #001A5C;
  padding-top: 20px;
  position: relative;
}
.tab-w{
  width: 1200px;
  height: 216px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.tab-l{
  color: #fff;
  text-align: left;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 50px;
  opacity: 0.5;
  cursor:pointer;
}
li, ul {
    list-style: none;
}
.icp{
  width: 100%;
  font-size: 14px;
  color: #fff;
  opacity: 0.5;
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 10px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}
.qrcode{
  width: 100px;
  height: 100px;
}
.qrcode >img{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/lib/vfooter.vue